import axios from 'axios'
import { Toast } from 'vant'
import router from '@/router'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 30000
})

service.interceptors.request.use(
  config => {
    Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: '加载中...'
    })

    const token = sessionStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = token
    }
    return config
  },
  error => {
    Toast.clear()
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    Toast.clear()
    const result = response.data

    if (result.code != 0) {
      if (result.code === 403) {
        router.push('/403')
        return
      }
      /**
       * session失效
       */
      if (result.code === 401) {
        router.push('/401')
        return
      }
      if (response.config.url != '/invoice/vat/node/elec/show') {
        Toast({
          message: result.message || '出错',
          duration: 3 * 1000
        })

        return Promise.reject(new Error(result.message))
      }
      // Toast({
      //   message: result.message || '出错',
      //   duration: 3 * 1000
      // })

      // return Promise.reject(new Error(result.message))
    }
    return result
  },
  () => {
    Toast.clear()

    Toast({
      message: '系统繁忙，请稍后',
      duration: 3 * 1000
    })
  }
)

export default service
